import {useEffect, useState} from 'react';
import { IconButton } from '@mui/material'
import NorthIcon from '@mui/icons-material/North';
import { Login } from './components/login/Login';
import {BrowserRouter, Routes, Route, useNavigate} from "react-router-dom";
import { Navigator } from './components/navigation/Navigator';
import { Devices } from './components/devices/Devices';
import { CreateJson } from './components/create-json/CreateJson';
import { AppUpload } from './components/upload/AppUpload';
import { MaterialJson } from './components/material-json/MaterialJson';
import { MenuListJson } from './components/menu-list-json/MenuListJson';
import { BundleJson } from './components/bundle-json/BundleJson';
import { Layout } from './components/navigation/Layout';
import { RequireAuth } from './components/navigation/RequireAuth';
import { Activity } from "./components/activity/activity";
import { Distributors} from "./components/distributors/Distributors";
import {useAuth} from "./context/useAuth";
import {DefaultConfiguration} from "./components/default-configuration/DefaultConfiguration";



  function App() {
  const { auth, setAuth } = useAuth();
  const navigate = useNavigate();
  const [isBtnUpVisible, setIsBtnUpVisible] = useState(null);
  let [userRoleData, setUserRoleData] = useState(null);
  let updateUserRole = (value) => {
    setUserRoleData(value)
  }

  useEffect(() => {
    if (userRoleData === null ) {
      if (JSON.parse(localStorage.getItem('currentVisitorFAPP')) === null ) {
        localStorage.setItem('currentVisitorFAPP', null);
      } else {
        setAuth(JSON.parse(localStorage.getItem('currentVisitorFAPP')))
        updateUserRole(JSON.parse(localStorage.getItem('currentVisitorFAPP')))
        navigate('/')
      }
    } else {
      localStorage.currentVisitorFAPP = JSON.stringify(userRoleData)
    }
  }, [userRoleData]);


  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScroll = () => {
    setIsBtnUpVisible(window.scrollY > 0);
  };



  return (
    <>
    <Routes>
      <Route path='/login' element={<Login callBackFromParent={updateUserRole} userRole={userRoleData}/>}/>

      <Route element={<RequireAuth />}>
        <Route path='/' element={<Layout userRole={userRoleData} />} >
          <Route index element={<Distributors userRole={userRoleData} />} />
          {/*<Route path='devices' element={<Devices userRole={userRoleData} />} />*/}
          {/*<Route path='/material-json' element={<MaterialJson/>} />*/}
          {/*<Route path='/menu-json' element={<MenuListJson/>} />*/}
          {/*<Route path='/bundle-json' element={<BundleJson/>} />*/}
          <Route path='/add-json' element={<CreateJson userRole={userRoleData} />} />
          <Route path='/add-json/default-configuration' element={<DefaultConfiguration />} />
          {/*<Route path='/users-activity' element={<Activity />} />*/}
          {/*<Route path='/upload-app' element={<AppUpload/>} />*/}
        </Route>
      </Route>
    </Routes>
        <IconButton
          sx={{
            ':hover': {backgroundColor: "rgba(0, 0, 0, 0.5)", color: "white"},
            '& .MuiSvgIcon-root': {width: "4vw", height: "4vw"},
          }}
          size="large"
          style={
            isBtnUpVisible
              ? {
                position: "fixed",
                right: "1.4vw",
                bottom: "5vw",
                zIndex: 1,
              }
              : { display: "none" }
          }
          onClick={() => {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          }}>
          <NorthIcon />
        </IconButton>
    </>
  );
}

export default App;

/*
<div>
    {auth != null ? (
      <>
      <Navigator/>
      <Routes>
        <Route path='/' element={<Devices/>} />
        <Route path='/material-json' element={<MaterialJson/>} />
        <Route path='/menu-json' element={<MenuListJson/>} />
        <Route path='/bundle-json' element={<BundleJson/>} />
        <Route path='/add-json' element={<CreateJson/>} />
        <Route path='/upload-app' element={<AppUpload/>} />
      </Routes>
      </>
    ): (
      <Routes>
        <Route path='/' element={<Login/>} />
      </Routes>
    )}
    </div>
*/
